export default __webpack_public_path__ + "static/media/Mentor-Banner.a06a4f4d.jpg";